import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LeadOwnerSearchComponent } from './lead-owner-search.component';

const routes: Routes = [{ path: '', component: LeadOwnerSearchComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LeadOwnerSearchRoutingModule { }
